module.exports = "//public.zight.com/packs/media/images/onboarding/in-browser-icon-707e30ab28cb065f3c083043bc470b0b.svg";